export interface PaymentDetails {
  amount: number;
  country: string;
  currency: string;
  channel: string;
  createdAt: string;
  oneTimePayment: boolean;
  status: string;
  userReference: string;
  provider: string;
  providerInitiated: boolean;
  platformSettled: boolean;
  notificationMode: boolean;
  notificationUrl: string;
  notificationStatus: boolean;
  notificationRetryCount: number;
  paymentUrl: string;
  paymentUrlReference: string;
  clientRef: string;
  clientId: string;
  referenceId: string;
  clientLogo: string;
  callbackURL: string;
  redirectUrl: string;
  clientName: string;
  fees?: string;
  feeBearer?: string;
  userId?: string;
}

export class PaymentPageDetails {
  clientId: string;
  reference: string;
  pageName: string;
  narration: string;
  clientLogo: string;
  metaData: {
    name: string;
    lineItem: [{ itemName: string; itemCode: string; itemAmount: number }];
  };
  customLink: string;
  active: boolean;
  saveCustomerDetails: boolean;
  allowPartialPayment: boolean;
  scheduleType: string;
  scheduleFrequencyDays: number;
  lastUpdatedAt: string;
  clientName: string;
  currency: string;
  isAmountFixed: boolean;
}
